<template>
    <div class="mm-table" :class="{mobile: mobileView}">
        <div  class="table-filter py-2">
            <div class="row justify-content-end">
                <div class="col" :class="{'col-xl-6 col-lg-8' : searchNoFullWidth }">
                    <div class="d-flex align-items-stretch">
                        <div class="border-radius-color w-100 p-1">
                            <div class="w-100 position-relative" :class="{'is-active': search_focus, 'border-0': mobileView}">
                                <input type="text" class="search-input form-control border-0 shadow-none" 
                                    v-model="filterText" 
                                    @focus="search_focus = true"
                                    @blur="search_focus = false" :placeholder="placeholderBusquedaRapida">
                                <div class="clear-search position-absolute">
                                    <button v-show="filterText!=''" @click="filterText=''" class="border-0"><i class="mm-icon mm-icon-cancel"></i></button>
                                </div>
                            </div>
                        </div>
                        <div class="border-radius-color p-2 ml-1" v-show="showFiltersButton">
                            <a href="#" v-on:click.prevent="toggleFilters" class="more-filters text-nowrap ml-2">
                                <svg height="22" width="22" focusable="false" fill="currentColor" viewBox="0 0 22 22" aria-hidden="false" aria-labelledby="equalizer-hl17o" role="img"><path d="M.75 8.25h11.33a4.5 4.5 0 008.84 0h2.33a.75.75 0 000-1.5h-2.33a4.5 4.5 0 00-8.84 0H.75a.75.75 0 000 1.5zM16.5 4.5a3 3 0 110 6 3 3 0 010-6zM23.25 15.75H11.92a4.5 4.5 0 00-8.84 0H.75a.75.75 0 000 1.5h2.33a4.5 4.5 0 008.84 0h11.33a.75.75 0 000-1.5zM7.5 19.5a3 3 0 110-6 3 3 0 010 6z"></path></svg>
                                <span class="align-middle px-2"><b>Filtros</b></span><span class="badge badge-primary" v-show="sumFiltersActives">{{sumFiltersActives}}</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="filters_panel position-relative" :class="{'showFilters': showFilters}">
                
                <ul class="list_filters d-flex list-unstyled mb-0">
                    <li v-for="(filter, index) in filtersHeader" v-bind:key="index" :class="{'open': filter.key==openedFilter}" class="p-2">
                        <div><button v-on:click="showOneFilter(index)" class="border-radius-color px-2 py-1">{{ getFilterName(filter.key) }} <span v-if="filter.actives.length>0" class="badge badge-primary">{{ filter.actives.length }}</span><i class="mm-icon mm-icon-down-open-big"></i></button></div>
                        <div class="filters_box mt-1" :class="{'backInUp': filter.key==openedFilter}">
                            <div class="p-3">
                                <div v-if="filter.type == 'select'" class="filters_search position-relative mb-2">
                                    <input type="text" v-on:keyup="onChangeFilter(index)" v-model="filter.textSearch" class="form-control" :placeholder="placeholderBusquedaProp" />
                                </div>
                                <div class="filters_display">
                                    <ul class="list-unstyled" v-if="filter.type == 'select' || filter.type == 'order'" :class="{'asc': sortBy && sortDirection, 'desc': sortBy && !sortDirection}">
                                        <li v-for="(value, j) in filter.values" v-bind:key="j" :class="{ active: filter.actives.includes(value.text) }" v-on:click="activeSelectFilter(index, value.text)"><div v-html="highlightsTxt(value.text, filter.textSearch)"></div></li>
                                    </ul>
                                    <div v-if="filter.type == 'date'">
                                        <label class="mb-0">Desde</label>
                                        <InputDate @keyup="(v) => onChangeDate(v, 'start', index)" v-model="filter.start" @click="(v) => clickInputDate(v, 'start', index)"></InputDate>
                                        <label class="mb-0 mt-3">hasta</label>
                                        <InputDate @keyup="(v) => onChangeDate(v, 'end', index)" v-model="filter.end" @click="(v) => clickInputDate(v, 'end', index)"></InputDate>
                                    </div>
                                </div>
                            </div>
                            <div class="filters_footer d-flex px-3 py-2">
                                <button class="w-100 btn btn-sm btn-secondary btn-neutral" v-on:click="showOneFilter(index)">Cerrar</button>
                                <button class="w-100 btn btn-sm btn-dark ml-1" v-on:click="clearFilter(index)" v-if="filter.type != 'order'">Limpiar</button>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <Datepicker ref="modaldatepicker"></Datepicker>

        <!-- :filter="'x'" para que siempre pase por filterFunction, si filter no tiene valor no pasa por filterFunction en cada item -->
        <div class="position-relative">
            <div class="table-responsive" ref="mmtableResponsive">
                <b-table show-empty
                    :items="itemsToTable" 
                    :per-page="perPage" 
                    :current-page="currentPage" 
                    :fields="headersTable" 
                    :filter="'x'"
                    :filter-function="filterFunction"
                    :tbody-tr-class="getTrClass"
                    :key="tableKey"
                    @filtered="onFiltered"
                    :selectable="isSelectable"
                    @row-selected="$emit('row-selected', ...arguments)"
                    @context-changed="idOpened=-1"
                    :busy="isBusy"
                    :sort-by="sortBy"
                    :sort-desc="sortDirection"
                    :thead-class="{'d-none': mobileView}"
                    :class="[{ 'empty':filteredCount==0 }, 'table-hover']">
                    <template v-for="slotName in Object.keys($scopedSlots)" v-slot:[slotName]="slotScope">
                        <slot :name="slotName" v-bind="slotScope"></slot>
                    </template>
                    <template #cell()="data">
                        <span v-if="mobileView && data.field.key==headers[0].key">
                            <slot name="mobile" v-bind="data.item"></slot>
                        </span>
                        <span v-else v-html="highlightsTxt(data.value, filterText)"></span>
                    </template>
                    <template #cell(actionsTable)="data">
                        <div>
                            <div class="dropdown b-dropdown" :class="data.index == idOpened ? 'position-absolute' : 'position-initial'" :ref="'menuAction'+data.index">
                                <button @click="openAction(data.index)" data-toggle="dropdown"><i class="demo-icon mm-icon-points"></i></button>
                                <ul class="dropdown-menu mt-1" :class="{'show' : data.index == idOpened}">
                                    <slot name="actions" v-bind="data"></slot>
                                </ul>
                            </div>
                        </div>
                    </template>
                    <template #emptyfiltered>
                        <EmptyTabla :noResultsProp="noResultsProp"></EmptyTabla>
                    </template>
                    <template #empty>
                        <EmptyTabla :noResultsProp="noResultsProp"></EmptyTabla>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger p-4">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <strong class="pl-2">Loading...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>

        <div v-show="!this.isBusy">
            <div class="table-footer p-2 d-flex align-items-center">  
                <div class="d-inline-flex" v-if="this.filteredCount>perPage">
                    <b-pagination
                        v-model="currentPage"
                        :total-rows="filteredCount"
                        :per-page="perPage"
                        prev-class="prev"
                        next-class="next"
                        aria-controls="my-table" first-number last-number
                    >
                        <template #prev-text><svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg></template>
                        <template #next-text><svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg></template>
                    </b-pagination>
                </div>
                <div class="pagination-resum d-inline-block">
                    <span v-show="this.filteredCount>perPage">{{perPage*(currentPage-1)+1}}->{{paginationCount()}} / </span>{{filteredCount}} registros
                </div>
            </div>
        </div>
    </div>

</template>


<script>
    import { BTable, BPagination  } from 'bootstrap-vue'
    import Datepicker from './mmDatepicker.vue';
    import InputDate from './mmInputDate.vue';
    import EmptyTabla from './mmTablaEmpty.vue'
    
    import moment from 'moment';
    export default {
        name: 'mmTabla',
        components: {
            BTable,
            BPagination,
            Datepicker,
            InputDate,
            EmptyTabla
        },
        data() {
            return {
                currentPage: 1,
                filteredCount: 0,
                filtersHeader: [],
                filterText: '',
                headersTable: [],
                idOpened: -1,
                initFilterText: 'x',
                isBusy: true,
                isSelectable: false,
                itemsToTable: [],
                mobileView: false,
                modalIndexFilter: 0,
                modalTitle: '',
                openedFilter: '',
                perPage: 20,
                search_focus: false,
                searchNoFullWidth: true,
                showFilters: false,
                showFiltersButton: false,
                sortBy: '',
                sortDirection: false,
                sumFiltersActives: 0,
                tableKey: 0,
                placeholderBusquedaRapida: 'Búsqueda rápida',
                placeholderBusqueda: 'Buscar',
                noResults: 'No hay resultados para mostrar'
            }
        },
        props: ['items', 'itemsPerPage', 'headers', 'searchFullWidth', 'selectable', 'placeholderBusquedaRapidaProp', 'placeholderBusquedaProp', 'noResultsProp'],
        created() {
            this.isSelectable = this.selectable!=undefined;
            this.mobileView = (window.innerWidth<768)
            
            if(this.headers!=undefined) {
                    
                    let valuesOrder =  [];

                    this.headers.forEach((header) => {
                        if('filterType' in header)
                            this.filtersHeader.push({key: header.key, type: header.filterType, textSearch: '', values: false, actives: [], start: '', end: ''})

                        if('sortable' in header && header.sortable)
                            valuesOrder.push({text: header.label});
                    });

                    if(valuesOrder.length && this.mobileView)
                        this.filtersHeader.push({key: '_order', type: 'order', textSearch: '', values: valuesOrder, actives: [], start: '', end: ''})

                    this.showFiltersButton = this.filtersHeader.length;
                    
                    let _headers = this.headers;
                    
                    if(Object.keys(this.$scopedSlots).includes("actions"))
                        _headers.push({
                            key: 'actionsTable',
                            label: '',
                            search: false,
                            class: 'mm-actions'
                        });

                    this.headersTable = this.mobileView ? [_headers[0]] : _headers;
                }

            if(this.itemsPerPage!=undefined) this.perPage = this.itemsPerPage;

            if (this.searchFullWidth != undefined) this.searchNoFullWidth = false;
            if (this.placeholderBusquedaRapidaProp != undefined) this.placeholderBusquedaRapida = this.placeholderBusquedaRapidaProp;
            if (this.placeholderBusquedaProp != undefined) this.placeholderBusqueda = this.placeholderBusquedaProp;
            if (this.noResultsProp != undefined) this.noResults = this.noResultsProp;
        },
        watch: {
            items: function(val) {
                this.updateItems(val);
            }
        },
        methods: {
            updateItems(val) {
                this.itemsToTable = val;
                this.filteredCount = val.length;
                this.isBusy = false;
            },
            handleScroll() {
                this.idOpened = -1;
            },
            openAction(index) {
                if(this.idOpened!=index) {
                    let _coordsT = this.$refs['mmtableResponsive'].getBoundingClientRect();
                    let _coords = this.$refs['menuAction'+index].getBoundingClientRect();
                    
                    this.$refs['menuAction'+index].style.top = (_coords.y-_coordsT.y)+'px';
                    this.$refs['menuAction'+index].style.left = (_coords.x-_coordsT.x)+'px';
                }
                this.idOpened=this.idOpened==index ? -1 : index
            },
            filterFunction(item) {
                
                this.idOpened = -1;
                let result = true;
                let resultText = !this.filterText;

                    this.headers.map((header) => {
                        
                        if((header.search==undefined || header.search) && !resultText) {
                            
                            let itemValue = item[header.key];
                            if(header.formatter!=undefined)
                                itemValue = header.formatter(item[header.key]);
                            
                            resultText = this.highlights(itemValue, this.filterText);
                        }

                        let filter = this.filtersHeader.find(e => e.key == header.key);

                        if(filter!= undefined)
                        {
                            //filtro tipo select
                            if(filter.values && filter.actives.length>0) result = filter.actives.includes(item[header.key]);
                            
                            //filtro tipo fecha
                            if(result && (filter.start || filter.end)) {
                                let f = moment(item[header.key], 'DD/MM/YYYY', true);
                                let start = moment(filter.start, 'DD/MM/YYYY', true);
                                let end = moment(filter.end, 'DD/MM/YYYY', true);

                                if(start.isValid()) result = start.isSameOrBefore(f);
                                if(result && end.isValid()) result = end.isSameOrAfter(f);
                            }
                        }   
                    });

                return result && resultText;
            },
            getFilterName(key)
            {
                let name = this.headers.find((element) => element.key == key);
                
                return name == undefined  ? key : name.label;
            },
            onChangeFilter(index)
            {
                this.valuesListFilter(index);
            },
            onChangeDate(value, id, index) {
                
                this.toggleDateToActives(value, index, id);
            },
            paginationCount()
            {
                return this.perPage*this.currentPage>this.filteredCount ? this.filteredCount : this.perPage*this.currentPage;
            },
            onFiltered(filteredItems) {
                this.filteredCount = filteredItems.length;
            },
            toggleFilters()
            {
                this.showFilters = !this.showFilters;
                this.openedFilter = '';
            },
            showOneFilter(index)
            {
                if(this.openedFilter == this.filtersHeader[index].key)
                    this.openedFilter = '';
                else {
                    this.openedFilter = this.filtersHeader[index].key;
                    this.valuesListFilter(index);
                }
            },
            activeSelectFilter(index, v)
            {
                if(this.filtersHeader[index].type == 'order') {
                    this.clearFilter(index);
                    this.sortDirection = !this.sortDirection;
                    this.sortBy = this.headers.find((h) => h.label == v).key;
                }

                let found = this.filtersHeader[index].actives.indexOf(v);
                
                //si el elemento no existe, se añade sino se eleminia, asi se desactiva como activo de la lista
                if(found == -1) {
                    this.filtersHeader[index].actives.push(v);
                } 
                else {
                    this.filtersHeader[index].actives.splice(found, 1);
                }
                    
            
                this.sumFiltersActives += found == -1 ? 1 : -1;
            },
            valuesListFilter: function (index) {
                
                if(this.filtersHeader[index].type != 'select') return;

                let result = [];

                if(this.openedFilter)
                    for(var i=0; i<this.items.length; i++) {
                        if(result.length==10) break;

                        let value = String(this.items[i][this.openedFilter]).trim();

                        let found = result.some(e => e.text == value);

                        if(value && !found && this.highlights(value, this.filtersHeader[index].textSearch))
                            result.push({text: this.items[i][this.openedFilter]});
                    }
            
                this.filtersHeader[index].values = result;
            },
            clearFilter(index) {
                this.openedFilter = '';
                this.filtersHeader[index].textSearch = '';
                this.filtersHeader[index].start = '';
                this.filtersHeader[index].end = '';
                this.sumFiltersActives -= this.filtersHeader[index].actives.length;
                this.filtersHeader[index].actives = [];
            },
            highlightsTxt(value, compareText) {
                
                try {
                    value = value.toString();
                    let re = new RegExp(compareText.toString(), 'ig')
                    var match = value.match(re);

                    return this.highlights(value, compareText) ? value.replace(match[0], '<i class="highlight">' + match[0] + '</i>') : value;

                } catch(error) {
                    return value;
                }
            },
            highlights(value, compareText) {
                
                try {

                    let re = new RegExp(compareText.toString(), 'ig')
                    var match = value.toString().match(re);

                    return match;
                } catch(error) {
                    return false;
                }
            },
            clickInputDate(value, id, index) {
                
                let self = this;
                
                this.$refs.modaldatepicker.openModal(value, function(v) {
                    
                    self.toggleDateToActives(v, index, id);
                });
            },
            toggleDateToActives(value, index, id) {
                
                let fecha = moment(value, 'DD/MM/YYYY', true);
                let active = this.filtersHeader[index].actives.indexOf(id);

                if(fecha.isValid()) {
                    
                    this.filtersHeader[index][id] = fecha.format('DD/MM/YYYY');
                    //se añade una vez el id en el array de actives, para contabilizar como 1 filtro
                    if(active == -1) {
                        this.sumFiltersActives++
                        this.filtersHeader[index].actives.push(id);
                    }
                } else {
                    if(active != -1) {
                        this.filtersHeader[index].actives.splice(active, 1);
                        this.sumFiltersActives--;
                    } 
                }
            },
            getTrClass(item) {
                return {'deleteAnime': item!=null && Object.keys(item).includes('removed')}
            },
            removeRow(key, value) {
                
                let itemFound = this.itemsToTable.findIndex(element => element[key] == value);
                
                if(itemFound!=-1) {
                    //con esto provocamos la animacion css
                    this.itemsToTable[itemFound]['removed'] = 1;
                    setTimeout(() => this.itemsToTable.splice(itemFound, 1), 500);
                }
            },
            activeRow(key, value) {
                let itemFound = this.itemsToTable.findIndex(element => element[key] == value);
                
                if(itemFound!=-1)
                    this.itemsToTable[itemFound]['isActive'] = true;
            },
            updateTable(forceUpdate) {
                this.updateItems(this.items);
                if(forceUpdate!=undefined) this.tableKey++;
            }
        }
    }
</script>